import Vue from 'vue'
import Vuex from 'vuex'

import {
  getDictInfoNew
} from './api/api.js'

Vue.use(Vuex)
window.addEventListener('popstate', function () {
  history.pushState(null, null, document.URL)
})

export default new Vuex.Store({
  state: {
    memuIdx: 1,
    userName: "",
    screenHeight: document.documentElement.clientHeight,
    isCollapse: false,
    leftIsCollapse: true,
    rightIsCollapse: false,
    memuFunList: [], //功能菜单及权限
    handleFucList: [], // 功能权限
    dicList: [], //数据字典数据
    msg: "",
    saveAllList: '',
    region: '',
    indexActive:"",
    imgUrl: '', //存储头像的照片url
    img:"",
    userInfos: "",
    operStep:""
  },
  mutations: {
    setImg(state, payload) {
      state.imgUrl = payload; //将载荷的值给vuex
    },
    updateData(state, data) {
      state.saveAllList = data
    },
    setMenu(state, data) {
      state.memuIdx = data
    },
    setUserName(state, data) {
      state.userName = data
    },
    setIsCollapse(state, data) {
      state.isCollapse = data
    },
    setLeftIsCollapse(state, data) {
      state.leftIsCollapse = data
    },
    setRightIsCollapse(state, data) {
      state.rightIsCollapse = data
    },
    setMemuFunList(state, data) {
      state.memuFunList = data;
    },
    setHandleFucList(state, data) {
      state.handleFucList = data
    },
    setMsg(state, data) {
      state.msg = data
    },
    setDicList(state, data) {
      state.dicList = data
    },

  },
  actions: {
    async getDictData({
      commit
    }, data) {
      let response = await getDictInfoNew(data);
      if (response.code == "1000") {
        commit('setDicList', response.data)
      } else {
        commit('setMsg', response.msg)
      }
    },

  },
  modules: {},
  getters: {}
})